<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      style="margin:auto;background:transparent;display:block; opacity: 0.3"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <g>
        <animateTransform
          v-if="loading"
          attributeName="transform"
          type="rotate"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
          dur="0.2s"
          begin="0s"
          repeatCount="indefinite"
        ></animateTransform>
        <path
          fill="#333"
          d="M82.465 48.649c-1.462-.244-2.56-1.424-2.769-2.892l-.007-.05c-.212-1.468.508-2.912 1.843-3.558l4.227-2.045c1.541-.746 2.296-2.545 1.695-4.148a39.734 39.734 0 0 0-2.319-5.07c-.818-1.501-2.67-2.105-4.24-1.429l-4.315 1.856c-1.361.586-2.923.186-3.893-.934l-.033-.038c-.973-1.12-1.147-2.724-.373-3.989l2.448-4.002c.892-1.459.558-3.378-.812-4.402a39.942 39.942 0 0 0-4.685-3.017c-1.501-.825-3.39-.334-4.348 1.086l-2.62 3.885c-.831 1.232-2.365 1.738-3.789 1.316l-.052-.015c-1.42-.418-2.431-1.671-2.464-3.152l-.104-4.69c-.039-1.746-1.415-3.15-3.157-3.269a39.57 39.57 0 0 0-5.394 0c-1.742.119-3.118 1.523-3.157 3.269l-.104 4.69c-.033 1.48-1.043 2.734-2.464 3.152l-.052.015c-1.424.422-2.959-.085-3.789-1.316l-2.62-3.885c-.958-1.42-2.847-1.911-4.348-1.086a39.942 39.942 0 0 0-4.685 3.017c-1.37 1.024-1.705 2.943-.812 4.402l2.448 4.002c.774 1.265.6 2.869-.373 3.989l-.033.038c-.97 1.12-2.531 1.52-3.893.934l-4.315-1.856c-1.57-.675-3.422-.072-4.24 1.429a39.734 39.734 0 0 0-2.319 5.07c-.601 1.603.154 3.402 1.695 4.148l4.227 2.045c1.335.646 2.055 2.09 1.843 3.558l-.007.05c-.21 1.467-1.307 2.648-2.769 2.892l-4.631.771-2.797 3.508c.138 1.877.406 3.717.794 5.513.361 1.671 1.968 2.772 3.666 2.567l4.66-.565c1.47-.178 2.854.644 3.47 1.99l.022.048c.62 1.349.337 2.94-.764 3.937l-3.47 3.145c-1.269 1.15-1.487 3.089-.457 4.458a40.179 40.179 0 0 0 3.65 4.208c1.208 1.212 3.157 1.272 4.475.18l3.608-2.989c1.143-.947 2.757-1.002 4.004-.196l.043.028c1.246.801 1.862 2.289 1.477 3.719l-1.223 4.536c-.445 1.651.416 3.398 2.019 3.994a39.69 39.69 0 0 0 5.351 1.57c1.672.365 3.344-.638 3.863-2.268l1.424-4.481c.449-1.411 1.775-2.323 3.256-2.321h.05c1.481-.002 2.807.909 3.256 2.321l1.424 4.481c.518 1.631 2.191 2.634 3.863 2.268a39.69 39.69 0 0 0 5.351-1.57c1.603-.595 2.464-2.343 2.019-3.994l-1.223-4.536c-.386-1.43.231-2.918 1.477-3.719l.043-.028c1.247-.805 2.861-.75 4.004.196l3.608 2.989c1.318 1.092 3.267 1.032 4.475-.18a40.179 40.179 0 0 0 3.65-4.208c1.03-1.368.812-3.308-.457-4.458l-3.47-3.145c-1.101-.997-1.384-2.588-.764-3.937l.022-.048c.616-1.346 2-2.168 3.47-1.99l4.66.565c1.698.206 3.305-.895 3.666-2.567.388-1.796.656-3.636.794-5.513l-2.797-3.508-4.633-.771zM50 65c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15s15 6.716 15 15c0 8.284-6.716 15-15 15z"
          style="fill: rgb(51, 51, 51);"
        ></path>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style></style>
